/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DestinationDetail } from './DestinationDetail';
import {
    DestinationDetailFromJSON,
    DestinationDetailFromJSONTyped,
    DestinationDetailToJSON,
} from './DestinationDetail';
import type { SourceDetail } from './SourceDetail';
import {
    SourceDetailFromJSON,
    SourceDetailFromJSONTyped,
    SourceDetailToJSON,
} from './SourceDetail';

/**
 * 
 * @export
 * @interface ReceivedMessage
 */
export interface ReceivedMessage {
    /**
     * 
     * @type {boolean}
     * @memberof ReceivedMessage
     */
    addressed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReceivedMessage
     */
    color?: string;
    /**
     * 
     * @type {DestinationDetail}
     * @memberof ReceivedMessage
     */
    destination?: DestinationDetail;
    /**
     * 
     * @type {string}
     * @memberof ReceivedMessage
     */
    formattedTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivedMessage
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReceivedMessage
     */
    safety?: boolean;
    /**
     * 
     * @type {SourceDetail}
     * @memberof ReceivedMessage
     */
    source?: SourceDetail;
    /**
     * 
     * @type {string}
     * @memberof ReceivedMessage
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivedMessage
     */
    text?: string;
    /**
     * 
     * @type {Date}
     * @memberof ReceivedMessage
     */
    time?: Date;
}

/**
 * Check if a given object implements the ReceivedMessage interface.
 */
export function instanceOfReceivedMessage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReceivedMessageFromJSON(json: any): ReceivedMessage {
    return ReceivedMessageFromJSONTyped(json, false);
}

export function ReceivedMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceivedMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'addressed': !exists(json, 'addressed') ? undefined : json['addressed'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'destination': !exists(json, 'destination') ? undefined : DestinationDetailFromJSON(json['destination']),
        'formattedTime': !exists(json, 'formatted_time') ? undefined : json['formatted_time'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'safety': !exists(json, 'safety') ? undefined : json['safety'],
        'source': !exists(json, 'source') ? undefined : SourceDetailFromJSON(json['source']),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'time': !exists(json, 'time') ? undefined : (new Date(json['time'])),
    };
}

export function ReceivedMessageToJSON(value?: ReceivedMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'addressed': value.addressed,
        'color': value.color,
        'destination': DestinationDetailToJSON(value.destination),
        'formatted_time': value.formattedTime,
        'id': value.id,
        'safety': value.safety,
        'source': SourceDetailToJSON(value.source),
        'status': value.status,
        'text': value.text,
        'time': value.time === undefined ? undefined : (value.time.toISOString()),
    };
}

